import alerts from 'common/modules/alerts';

export default (isPage, callback) => (dispatch) => {
    const message = isPage
        ? '¿Está realmente seguro de eliminar esta página?'
        : '¿Está realmente seguro de eliminar estas páginas?';
    const dataAlert = {
        confirmText: 'Eliminar',
        messages: [message],
        onSuccess: () => callback(),
        title: 'Confirmación',
        type: alerts.ALERT_TYPE_CONFIRM,
    };

    dispatch(alerts.actions.show(dataAlert));
};
